import * as S from './ProjectListItem.styles.js';
import { AppUserLink } from '@/components/AppUserLink/AppUserLink.js';
import { ClipEnter } from '@/components/Motion/ClipEnter/ClipEnter.js';
import { getNameArrayFromRoleToolNodeList } from '@/components/Resource/utils.js';
import { WithSampleTag } from '@/components/WithSampleTag/WithSampleTag.js';
import { WrapWithArrow } from '@/components/WrapWithArrow/WrapWithArrow.js';
import { useHeadlineVariant } from '@/hooks/useHeadlineVariant.js';
import { useIsPage } from '@/hooks/useIsPage.js';
import { type ResourceNode } from '@/hooks/useResourceNode/types.js';
import { useProjectNode } from '@/hooks/useResourceNode/useProjectNode.js';
import { type ProjectNode } from '@/types/projects.js';
import { type ComponentProps } from 'react';

export const ProjectListItem = ({
  index,
  node,
  ...props
}: ComponentProps<typeof S.ProjectAnchor> & ResourceNode<ProjectNode>) => {
  const { isProjectPage } = useIsPage();
  const headlineFontFamily = useHeadlineVariant();
  const { roles, title } = node;
  const { anchorProps, href, isMock } = useProjectNode({ index, node });
  const roleList = getNameArrayFromRoleToolNodeList(roles.edges).join(', ');

  return (
    <AppUserLink href={href}>
      <S.ProjectAnchor
        {...props}
        {...anchorProps}
      >
        <S.StyledFlexRow>
          <S.Title
            as="h5"
            fontFamily={headlineFontFamily}
          >
            <WithSampleTag
              isMock={isMock}
              sampleType="project"
            >
              <WrapWithArrow
                customArrow={
                  <ClipEnter
                    css={{
                      alignItems: 'inherit',
                      display: 'inherit',
                    }}
                    delay={0.5}
                  >
                    <S.StyledArrowRightIcon />
                  </ClipEnter>
                }
                margin={4}
                text={title}
              />
            </WithSampleTag>
          </S.Title>
        </S.StyledFlexRow>
        <S.Roles isProjectPage={isProjectPage}>{roleList}</S.Roles>
      </S.ProjectAnchor>
    </AppUserLink>
  );
};
